module.exports = __webpack_public_path__ + "img/team-chart-line-green.7d215128.png";